export default __webpack_public_path__ + "static/media/home-interior-design-slider-img01.9b2992f2.jpg";